import React, { useState, useEffect } from "react";
import "./deathDashboard.css";
import fileImage from "../../assets/images/DeathModuleNew/fileuploaded.png";
import addIcon from "../../assets/images/DeathModuleNew/addIcon.png";
import dotIcon from "../../assets/images/DeathModuleNew/dotIcon.png";
import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
import moment from "moment";
import { Link } from "react-router-dom";
import { Modal } from "antd";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";

export const StartMessageDashboard = (props) => {
  const [fileUpload, setFileUpload] = useState(null);
  const [fileUploadAspects, setFileUploadAspects] = useState(null);

  const [loading, setLoading] = useState(false);
  const [accessModal, setaccessModal] = useState(false);

  const showAccessModal = () => {
    setaccessModal(true);
  };

  const getFile = async () => {
    const ID = localStorage.getItem("accessId");
    if (
      (props.role === "protrustee" || props.role === "trustee") &&
      ID === null
    ) {
      console.log("here to show modal");
      showAccessModal();
    }

    setLoading(true);
    let dataFile = await DEATH_API.getAdvanceHealth(ID);
    if (dataFile && dataFile.data) {
      setFileUpload(dataFile.data);
    }

    setLoading(false);
  };
  useEffect(() => {
    getFile();
  }, []);
  return (
    <div>
      <div
        className="cardHeading"
        style={{
          marginTop: "8px",
          marginBottom: "8px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        START HERE
        <ToolTipCreator name={"Death_Start_Here"}/>
      </div>
        <div className="uploadButtons" style={{ width: "20px" }}>
          {" "}
          <div className="upload" style={{ width: "20px", height: "20px" }}>
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <div
        className="cardDesc"
        style={{ marginTop: "8px", marginBottom: "8px" }}
      >
        Click here to access the first step of thirteen that will proactively
        plan your end-of-life wishes for your family and the people you love.
      </div>
      <div
        className="cardHeading"
        style={{
          marginTop: "8px",
          marginBottom: "8px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        Advance Healthcare Directive{" "}
      </div>
      {fileUpload && fileUpload.advanceHealthCareDirectiveDocument ? (
        <div style={{ display: "flex", flexWrap:"wrap" }}>
          <img src={fileImage} height={80} width={85} alt="fileImage"></img>
          <div style={{ marginLeft: "1.5rem", marginTop: "1rem",wordBreak:"break-all" }}>
            <div>
              {" "}
              <a
                style={{ color: "#7D8FB3" }}
                href={
                  fileUpload && fileUpload.advanceHealthCareDirectiveDocument
                }
                target="blank"
              >
                {fileUpload && fileUpload.advanceHealthCareDirectiveFileName
                  ? fileUpload.advanceHealthCareDirectiveFileName
                  : ""}
              </a>{" "}
            </div>
            <div style={{ color: "#7d8fb3" }}>
              {" "}
              {fileUpload &&
                fileUpload.advanceHealthCareDirectiveDate &&
                moment(fileUpload.advanceHealthCareDirectiveDate).format(
                  "MM-DD-YYYY"
                )}
            </div>
          </div>
        </div>
      ) : (
        "No File Uploaded"
      )}
      <Modal
        title={
          <span style={{ textAlign: "center", display: "block" }}>
            Delegate Access Modal
          </span>
        }
        visible={accessModal}
        footer={null}
        closable={false}
      >
        <div style={{}}>
          <div className="">
            <h2 className="otp-heading">
              Please Select Client before Accessing this Module
            </h2>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Link to="/delgateAccess" style={{ width: "50%" }}>
                <div className="payButtonView">Go to Delegate Access</div>
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      <Loader isLoading={loading} />
    </div>
  );
};
